import { FormControlLabel, ListItem } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledListItem = styled(ListItem)({
  borderBottom: "1px solid #E1E1E1",
  padding: "16px",
  "&:last-child": {
    border: "none"
  }
})

const TodoListRow = ({ control, children, id }) => {
  return (
    <StyledListItem key={id}>
      <FormControlLabel control={control} />
      {children}
    </StyledListItem>
  )
}

export default TodoListRow
